import { render, staticRenderFns } from "./project_edit.vue?vue&type=template&id=70864fd3&"
import script from "./project_edit.vue?vue&type=script&lang=js&"
export * from "./project_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports